const RouteNames = {
  Home: 'Home',
  UserProfile: {
    Main: 'UserProfileMain',
    Notifications: {
      Basic: 'UserProfileNotificationsBasic',
      List: 'UserProfileNotificationsList',
    },
  },
  Applications: {
    Base: 'Applications',
    TargetAssistance: {
      Base: 'TargetAssistance',
      List: 'TargetAssistanceList',
    },
    MutualAidBoard: {
      Base: 'MutualAidBoard',
      List: 'MutualAidBoardList',
    },
    BecomeVolunteer: {
      Base: 'BecomeVolunteer',
      List: 'BecomeVolunteerList',
    },
    HelpWithTask: {
      Base: 'HelpWithTask',
      List: 'HelpWithTaskList',
    },
    Cooperation: {
      Base: 'Cooperation',
      List: 'CooperationList',
    },
    Presents: {
      Base: 'Presents',
      List: 'PresentList',
    },
    Events: {
      Base: 'Events',
      List: 'EventList',
    },
  },
  Exercises: {
    Base: 'Exercises',
    List: 'ExercisesList',
  },
  News: {
    Base: 'News',
    List: 'NewsList',
    Edit: 'NewsEdit',
    Create: 'NewsCreate',
    Detail: 'NewsDetail',
  },
  GoodDeedsBoard: {
    Base: 'GoodDeedsBoard',
    List: 'GoodDeedsBoardList',
  },
  EventsAdmin: {
    Base: 'EventsAdmin',
    List: 'EventsAdminList',
  },
  AddressCollections: {
    Base: 'AddressCollections',
    List: 'AddressCollectionsList',
  },
  Content: {
    Base: 'Content',
    List: 'ContentList',
  },
  Grants: {
    Base: 'Grants',
    List: 'GrantsList',
    Detail: 'GrantsDetail',
    Create: 'GrantsCreate',
  },
  TechnicalSupport: {
    Base: 'TechnicalSupport',
    List: 'TechnicalSupportList',
  },
  Tasks: {
    Base: 'Tasks',
    List: 'TasksList',
  },
  Calendar: {
    Base: 'Calendar',
  },
  About: {
    Base: 'About',
    List: 'AboutList',
  },
  Measures: {
    Base: 'MeasuresRoute',
    List: 'MeasuresList',
  },
  Analytics: {
    Base: 'AnalyticsBase',
  },
  /** 
   * После доработки раздела с аналитикой
   * объединить с роутами для аналитики
  */
  AnalyticsAndReports: {
    Base: 'AnalyticsAndReportsBase',
    Analitics: {
      Base: 'AnalyticsAndReportsAnaliticsBase',
    },
    Reports: {
      Base: 'AnalyticsAndReportsReportsBase',
      List: 'AnalyticsAndReportsReportsList',
    },
    LeisureCenters: {
      Base: 'AnalyticsAndReportsLeisureCentersBase',
      List: 'AnalyticsAndReportsLeisureCentersList',
    },
  },
  /** Список проектов (пагинация в URL, как у мер) */
  Projects: {
    Base: 'ProjectsRoute',
    List: 'ProjectsList',
  },
  /** Одна карточка проекта: просмотр, галерея, редактирование */
  Project: {
    Create: 'ProjectCreate',
    Detail: 'ProjectDetail',
    DetailGallery: 'ProjectDetailGallery',
    Edit: 'ProjectEdit',
    EditGallery: 'ProjectEditGallery',
  },
  DonationRegistry: {
    Base: 'DonationRegistry',
    List: 'DonationRegistryList',
  },
  WardsAndVolunteers: {
    Base: 'WardsAndVolunteers',
    Wards: {
      Base: 'WardsAndVolunteersWards',
      List: 'WardsAndVolunteersWardsList',
      Detail: {
        Base: 'WardsAndVolunteersWardsDetail',
        CommonInfo: 'WardsAndVolunteersWardsDetailCommonInfo',
        Applications: {
          Base: 'WardsAndVolunteersWardsDetailApplications',
          List: 'WardsAndVolunteersWardsDetailApplicationsList',
        },
        Gamification: {
          Base: 'WardsAndVolunteersWardsDetailGamification',
          List: 'WardsAndVolunteersWardsDetailGamificationList',
        },
        EventRegistrations: {
          Base: 'WardsAndVolunteersWardsDetailEventRegistrations',
          List: 'WardsAndVolunteersWardsDetailEventRegistrationsList',
        },
        TargetAssistance: {
          Base: 'WardsAndVolunteersWardsDetailTargetAssistance',
          List: 'WardsAndVolunteersWardsDetailTargetAssistanceList',
        },
      },
    },
    Volunteers: {
      Base: 'WardsAndVolunteersVolunteers',
      List: 'WardsAndVolunteersVolunteersList',
      Detail: {
        Base: 'WardsAndVolunteersVolunteersDetail',
        CommonInfo: 'WardsAndVolunteersVolunteersDetailCommonInfo',
        Applications: {
          Base: 'WardsAndVolunteersVolunteersDetailApplications',
          List: 'WardsAndVolunteersVolunteersDetailApplicationsList',
        },
        Gamification: {
          Base: 'WardsAndVolunteersVolunteersDetailGamification',
          List: 'WardsAndVolunteersVolunteersDetailGamificationList',
        },
        EventRegistrations: {
          Base: 'WardsAndVolunteersVolunteersDetailEventRegistrations',
          List: 'WardsAndVolunteersVolunteersDetailEventRegistrationsList',
        },
        Donations: {
          Base: 'WardsAndVolunteersVolunteersDetailDonations',
          List: 'WardsAndVolunteersVolunteersDetailDonationsList',
        },
        Certificates: {
          Base: 'WardsAndVolunteersVolunteersDetailCertificates',
          List: 'WardsAndVolunteersVolunteersDetailCertificateslist',
        },
      },
    },
  },
  Gamification: {
    Base: 'Gamification',
    Tasks: 'GamificationTasks',
    Gifts: 'GamificationGifts',
    Rating: 'GamificationRating',
    Levels: 'GamificationLevels',
    Referral: 'GamificationReferral',
  },
  Advertising: {
    Base: 'Advertising',
  },
  Presentation: {
    Base:'Presentation',
  },
};

export default RouteNames;
